import { SVGProps } from 'react'

export const Image = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 3.25H21.25V21.25H3.25V3.25ZM4.75 4.75V14.6893L8.25 11.1893L12.25 15.1893L14.25 13.1893L19.75 18.6893V4.75H4.75ZM18.6893 19.75H4.75V16.8107L8.25 13.3107L12.25 17.3107L14.25 15.3107L18.6893 19.75ZM14.5 8.5C14.0858 8.5 13.75 8.83579 13.75 9.25C13.75 9.66421 14.0858 10 14.5 10C14.9142 10 15.25 9.66421 15.25 9.25C15.25 8.83579 14.9142 8.5 14.5 8.5ZM12.25 9.25C12.25 8.00735 13.2574 7 14.5 7C15.7426 7 16.75 8.00735 16.75 9.25C16.75 10.4927 15.7426 11.5 14.5 11.5C13.2574 11.5 12.25 10.4927 12.25 9.25Z"
      fill="currentColor"
    />
  </svg>
)

